<script>
import baseMixin from '@/mixins/baseMixin'
import BookingCardListSkeletonLoader from '@/components/skeleton/booking-card-list-skeleton-loader.vue'
import BookingListGroupSkeleton from '@/components/skeleton/booking-list-group-skeleton.vue'
import { LayoutToggle } from '@/shared/constants/layout/LayoutToggle.js'

export default {
  name: 'BookingSummarySkeletonLoader',
  components: {
    BookingCardListSkeletonLoader,
    BookingListGroupSkeleton,
  },
  mixins: [baseMixin],
  props: {
    count: {
      type: Number,
      default: 5,
    },
  },
  computed: {
    isTileLayout() {
      return this.dashboardLayout === LayoutToggle.TILE
    },
  },
}
</script>

<template>
  <BookingListGroupSkeleton v-if="isTileLayout" :rows="count" />
  <BookingCardListSkeletonLoader v-else :count="count" />
</template>
